import queryString from "query-string";
import { PureComponent } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { asyncState, validNumber } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type RoofingCalculatorState = {
    roofLength: number;
    roofWidth: number;
    roofArea: number;
};

class RoofingCalculator extends PureComponent<{}, RoofingCalculatorState> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);
        this.state = {
            roofLength: this.query.roofLength
                ? Number(this.query.roofLength)
                : 0,
            roofWidth: this.query.roofWidth ? Number(this.query.roofWidth) : 0,
            roofArea: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            roofArea: this.roofArea()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.roofing);
    }

    roofArea = () => {
        let roofArea = 0;

        const roofLength = this.state.roofLength;

        const roofWidth = this.state.roofWidth;

        if (validNumber(roofLength) && validNumber(roofWidth)) {
            roofArea = roofLength * roofWidth;
        }

        return Number(roofArea);
    };

    setCalculationValue = (field: string, value: string) => {
        const numberValue = parseFloat(value.replace(",", "."));
        this.setState(
            (state) => ({ ...state, [field]: numberValue }),
            () => {
                this.setState({ roofArea: this.roofArea() });

                CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.roofing);
            }
        );
    };

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            roofLength: this.state.roofLength,
            roofWidth: this.state.roofWidth
        };
        const resultProps = {
            roofArea: this.state.roofArea,
            mailParams: {
                roofLength: this.state.roofLength,
                roofWidth: this.state.roofWidth
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { RoofingCalculator };
